import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { Loader, BaasicTable, BaasicHeader } from 'core/components';

function ExitScanModeDetailTemplate({
	t,
	exitScanModeDetailViewStore,
	exitScanModeDetailViewStore: {
		pallet,
		data,
		rootStore,
		tableData,
		noDataItem,
		fulfillmentOrderStore,
		confirmDisable,
		onConfirm,
	},
}) {
	const loading = exitScanModeDetailViewStore.loading;
	if (loading) return <Loader />;
	return (
		<section>
			<div className="container--fluid">
				<BaasicHeader rootStore={rootStore} title={'EXITSCANDETAILVIEW.LABEL.PALLETDETAIL'} />
				<div className="order__wrapper">
					<div className="order__header">
						<div className="container--fluid">
							<div className="row">
								<div className="col col-sml-6 col-med-6 col-xlrg-3 col-xxlrg-3">
									<div className="order__header__item">
										<h4 className="order__header__title type--base">{t('EXITSCANDETAILVIEW.LABEL.CARRIERSERVICE')}</h4>
										<p>{t(pallet.carrierTypeServiceType.name)}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="order__details">
				<div className="container--fluid">
					<div className="row spc--top--med">
						<div className="col col-sml-12">
							<h4 className="order__box__title order__box__title--table">
								{t('EXITSCANDETAILVIEW.LABEL.FULFILLMENTORDERS')}
							</h4>
							<BaasicTable
								{...{
									data: data.slice(),
									tableData,
									listStore: fulfillmentOrderStore,
									actions: exitScanModeDetailViewStore,
									noDataItem,
								}}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="row order__details">
				<div className="col col-sml-3">
					<button className="btn btn--med btn--primary" type="button" disabled={confirmDisable} onClick={onConfirm}>
						{t('CONFIRM')}
					</button>
				</div>
			</div>
		</section>
	);
}

export default defaultTemplate(ExitScanModeDetailTemplate);
